export const RECAPTCHA_V2_CLIENT_SITE_KEY = '6LfOw9EnAAAAAEjfi_Fq4zZfM4XsYoVeSY5sJ8Pl';
export const RECAPTCHA_V3_CLIENT_SITE_KEY = '6LcrwtEnAAAAAPVs9i3ZYXlo73hrwSC0Px8J-CnW';